/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Entity/Form
 * @desc Filter Entity form
 */

import { getFieldSearchSelectEntity } from 'labstep-web/components/FilterPost/NewIndex/Entity/Form/fields';
import type { FilterPostReportEntityFormProps } from 'labstep-web/components/FilterPost/NewIndex/Entity/Form/types';
import { FormReusableGroup } from 'labstep-web/core/Form/Reusable/Group';
import { useActiveGroup } from 'labstep-web/hooks/activeGroup';
import { PostFilter } from 'labstep-web/services/postFilter';
import type { PostFilterComparisonType } from 'labstep-web/services/postFilter/constants';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import { useCallback } from 'react';

export const getPostFilterEntity = (
  field: string,
  comparison: PostFilterComparisonType,
  path?: string,
) => {
  return new PostFilter([[field, comparison]], path);
};

export const FilterPostReportEntityForm: React.FC<
  FilterPostReportEntityFormProps
> = ({
  addPostFilter,
  onDone,
  path,
  field,
  defaultValues,
  entityName,
  extraParams,
}) => {
  const onSubmit = useCallback(
    (values): void => {
      const { entity_id } = values;
      addPostFilter(
        getPostFilterEntity(
          field,
          PostFilterComparison.eq,
          path,
        ).getNode([entity_id]),
        true,
      );
      onDone();
    },
    [path, addPostFilter],
  );

  const { activeGroup } = useActiveGroup();

  return (
    <FormReusableGroup
      fields={[
        getFieldSearchSelectEntity(
          entityName,
          activeGroup || undefined,
          extraParams,
        ),
      ]}
      onSubmit={onSubmit}
      onDone={onDone}
      defaultValues={defaultValues}
      addAnother={false}
    />
  );
};
